export const messages = {
  en: {
    buildingForm: {
      search: {
        title: 'Building Form Search',
        buildingName: 'Building Name',
        userName: 'Customer Name',
        userTel: 'Phone Number'
      },
      list: {
        title: 'Building Form List'
      },
      table: {
        id: 'ID',
        buildingName: 'Building Name',
        userName: 'Customer Name',
        userTel: 'Phone Number',
        createTime: 'Create Time',
        statusCd: 'Status'
      },
      add: {
        title: 'Add Building Form',
        buildingName: 'Building Name',
        buildingNamePlaceholder: 'Please enter building name',
        userName: 'Customer Name',
        userNamePlaceholder: 'Please enter customer name',
        userTel: 'Phone Number',
        userTelPlaceholder: 'Please enter phone number',
        statusCd: 'Status',
        statusCdPlaceholder: 'Please select status'
      },
      edit: {
        title: 'Edit Building Form',
        buildingName: 'Building Name',
        buildingNamePlaceholder: 'Please enter building name',
        userName: 'Customer Name',
        userNamePlaceholder: 'Please enter customer name',
        userTel: 'Phone Number',
        userTelPlaceholder: 'Please enter phone number',
        statusCd: 'Status',
        statusCdPlaceholder: 'Please select status'
      },
      delete: {
        title: 'Delete Building Form',
        confirmText: 'Are you sure you want to delete this building form?' 
      },
      status: {
        valid: 'Valid',
        invalid: 'Invalid'
      },
      validate: {
        buildingNameRequired: 'Please enter building name',
        buildingNameMaxLength: 'Building name cannot exceed 100 characters',
        userNameRequired: 'Please enter customer name',
        userNameMaxLength: 'Customer name cannot exceed 50 characters',
        userTelRequired: 'Please enter phone number',
        userTelFormat: 'Please enter a valid phone number',
        userTelMaxLength: 'Phone number cannot exceed 20 characters',
        statusCdRequired: 'Please select status'
      }
    }
  },
  zh: {
    buildingForm: {
      search: {
        title: '房产留资查询',
        buildingName: '楼盘名称',
        userName: '客户姓名',
        userTel: '联系电话'
      },
      list: {
        title: '房产留资列表'
      },
      table: {
        id: '序号',
        buildingName: '楼盘名称',
        userName: '客户姓名',
        userTel: '联系电话',
        createTime: '留资时间',
        statusCd: '状态'
      },
      add: {
        title: '新增房产留资',
        buildingName: '楼盘名称',
        buildingNamePlaceholder: '请输入楼盘名称',
        userName: '客户姓名',
        userNamePlaceholder: '请输入客户姓名',
        userTel: '联系电话',
        userTelPlaceholder: '请输入联系电话',
        statusCd: '状态',
        statusCdPlaceholder: '请选择状态'
      },
      edit: {
        title: '编辑房产留资',
        buildingName: '楼盘名称',
        buildingNamePlaceholder: '请输入楼盘名称',
        userName: '客户姓名',
        userNamePlaceholder: '请输入客户姓名',
        userTel: '联系电话',
        userTelPlaceholder: '请输入联系电话',
        statusCd: '状态',
        statusCdPlaceholder: '请选择状态'
      },
      delete: {
        title: '删除房产留资',
        confirmText: '确定要删除这条房产留资记录吗？'
      },
      status: {
        valid: '有效',
        invalid: '无效'
      },
      validate: {
        buildingNameRequired: '请输入楼盘名称',
        buildingNameMaxLength: '楼盘名称不能超过100个字符',
        userNameRequired: '请输入客户姓名',
        userNameMaxLength: '客户姓名不能超过50个字符',
        userTelRequired: '请输入联系电话',
        userTelFormat: '请输入正确的手机号码',
        userTelMaxLength: '联系电话不能超过20个字符',
        statusCdRequired: '请选择状态'
      }
    }
  }
}